import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { AuthContext } from '../../shared/context/auth-context';
import Passcode from './passcode/Passcode';

// Types
interface SignupScreen5Props {
  error: string | undefined;
  passcode: string;
  handleContinue: (dataObj: any) => void;
}

export function SignupScreen5({ error, passcode, handleContinue }: SignupScreen5Props) {
  const auth = useContext(AuthContext);
  const { t } = useTranslation();

  const handleContinueForm = (code: string) => {
    const dataObj = {
      progress: 'screen5',
      code,
    };
    handleContinue(dataObj);
  };

  const handleReset = () => {
    const dataObj = {
      progress: 'screen5',
      code: 'reset',
    };
    handleContinue(dataObj);
  };

  return (
    <>
      <h1 data-testid="confirm-passcode-title">{t('R039')}</h1>
      <p>{t('R040')}</p>
      {!auth.isLoggedIn && (
        <Passcode
          passcode={passcode}
          confirm
          handleContinue={handleContinueForm}
          handleReset={handleReset}
        />
      )}
      {error && (
        <p className="login_error" role="alert">
          {' '}
          <FontAwesomeIcon icon={faTriangleExclamation} className="icon" />
          <span dangerouslySetInnerHTML={{ __html: error }} />
        </p>
      )}
    </>
  );
}
